import { truncateSync } from "fs";
import { json } from "node:stream/consumers";
import { Col, Row } from "react-flexbox-grid";
import {Project, ProjectTag, ConcreteProject} from "../classes/Project";
import WebLink from "../classes/WebLink";
import Spacer from "../components/Spacer/Spacer";
import tagsModel from "./tagsModel";


class ProjectsModel {

    allProjects: Map<string, Project>;
    
    constructor(){ 
        this.allProjects = new Map();
    };

    getProjectByKey(key: string): Project | null {

        return this.allProjects.get(key) ?? null;
    }

    removeProject(key: string) {
        this.allProjects.delete(key);
    }
    
    addProject(projectKey: string, project: Project) {

        projectsModel.allProjects.set(projectKey, project);
    }

    getAllProjectKeys(conditions?: {includeTags?: Array<ProjectTag>, }): Array<string> {

        let selected: Map<String, Project> = new Map();

        let keys = Array.from(this.allProjects.keys());

        if (conditions === undefined) {
            return keys;
        }

        return keys.filter((key) => {

            let p: Project = this.getProjectByKey(key)!;

            // filter by tags (AND)
            let okTags = true; 
            if (conditions.includeTags !== undefined && conditions.includeTags.length>0) {

                for (let i=0; i<conditions.includeTags.length && okTags; i++) {
                    let tag = conditions.includeTags[i];

                    if (p.tags.indexOf(tag)<0) {
                        // tag not found => exclude this
                        okTags = false;
                    } 
                }
            }

            return okTags;
        });
    }
}

/** Unique instance of the projects model */
const projectsModel: ProjectsModel = new ProjectsModel();

// add Uniud Sailing Lab
// projectsModel.addProject("uniud-sailing-lab-neptune-2-0", new ConcreteProject({
//     id: 1, 
//     title: "Progettazione e sviluppo di Neptune 2.0 (Tesi di laurea)", 
//     subtitle: "Un altro componente software per il campo di regata 4.0 di Uniud Sailing Lab.", 
//     imageSrc: "/img/progetti/neptune-nav.png", 
//     markdownBody: "Il progetto Neptune 2.0 consiste nella progettazione e nello sviluppo di un sistema software modulare e stratificato per il contesto nautico. Il sistema \u00E8 costituito da una _componente real-time_ (scritta in Python ed accessibile tramite web API) e da _un'interfaccia web_ (un'applicazione in React js). Esso fornisce al navigante una serie di funzionalit\u00E0 utili in mare, come ad esempio:\r\n\r\n*   la visualizzazione di vari dati (raccolti da un altro applicativo al quale ci si interfaccia),\r\n*   la navigazione con il supporto di una mappa nautica,\r\n*   la gestione di una collezione di punti GPS,\r\n*   il calcolo della distanza e dell'angolo rispetto ad una destinazione.\r\n\r\nIl lavoro \u00E8 stato svolto nel contesto del laboratorio dell'Universit\u00E0 degli Studi di Udine [Uniud Sailig Lab](https:\/\/lambda-iot.uniud.it\/sailing_lab\/website\/); \u00E8 durato circa 5 mesi ed \u00E8 stato portato avanti da tre programmatori. Questo progetto \u00E8 stata un'ottima occasione per sperimentare tecnologie _(e.g., React js, Flask, Unittest)_, ma anche effettuare attivit\u00E0 di progettazione _(e.g., definizione dei requisiti, progettazione architetturale, progettazione ad oggetti con UML, progettazione di web API)_ e applicare metodologie di sviluppo pseudo-agili _(e.g., sviluppo incrementale, test driven development, utilizzo del flusso di lavoro Gitflow)_.\r\n\r\nTutte queste tematiche vengono trattate nel dettaglio [nella mia tesi](\/files\/tesi-emanuele-lena-2021.pdf).", 
//     externalLinks: [
//         {
//             label: "Tesi [PDF]",
//             url: "/files/tesi-emanuele-lena-2021.pdf",  
//             title: "Emanuele Lena tesi di laurea uniud sailing lab", 
//             newPage: true, 
//         }, 
//         {
//             label: "Portale progetto USL",
//             url: "https://lambda-iot.uniud.it/sailing_lab/website/",  
//             title: "Uniud Sailing Lab portale", 
//             newPage: true, 
//         }, 
//     ], 
//     tags: [
//         tagsModel.getByKey("python")!, 
//         tagsModel.getByKey("react-js")!, 
//         tagsModel.getByKey("iot")!, 
//         tagsModel.getByKey("progettazione-sviluppo-software")!, 
//     ]
// }));


// projectsModel.addProject("sensori-parcheggio-iot", new ConcreteProject({
//     title: "Sistema di sensori di parcheggio IoT", 
//     subtitle: "Un esempio di sistema (distibuito) con MQTT, Docker, micro-controllori e React JS.", 
//     imageSrc: "/img/progetti/architettura-sensori-parcheggio-iot.jpg", 
//     markdownBody: "Il sistema qui descritto \u00E8 un prototipo di sistema di sensori di parcheggio, costruito da me e da tre miei colleghi nella prima met\u00E0 del 2021 (come progetto didattico).\r\n\r\n### Funzionalit\u00E0 del sistema\r\n\r\nIl sistema presenta le seguenti funzionalit\u00E0:\r\n\r\n*   lettura e presentazione all'utente delle distanze rilevate da tre sensori ad ultra-suoni;\r\n*   presentazione all'utente di un flusso video in tempo reale (la telecamera di parcheggio);\r\n*   allerta dell'utente tramite un feedback sonoro quando le distanze superano una certa soglia.\r\n\r\n### Architettura del sistema\r\n\r\nIl sistema \u00E8 implementato con _un'architettura distribuita_, costituita da un insieme di componenti hardware e software separati che collaborano tra loro per fornire i servizi descritti. Le diverse componenti comunicano attraverso il _broker Mosquito_. Riassumendo in breve:\r\n\r\n*   I sensori comunicano le loro letture pubblicando i valori delle distanze come messaggi MQTT;\r\n*   gli attuatori sonori e l'interfaccia del sistema restano in ascolto e - rispettivamente - producono l'output sonoro e aggiornano i valori numerici ogni qual volta le distanze cambiano;\r\n*   tramite una web-cam e il programma Motion si crea uno streaming video visibile da interfaccia web.\r\n\r\n![iot mqtt sistemi distribuiti](\/img\/progetti\/architettura-sensori-parcheggio-iot.jpg)\r\n\r\n_Architettura del sistema_\r\n\r\n![react iot interfaccia web](\/img\/progetti\/ui-sensori-parcheggio-iot.png)\r\n\r\n_Interfaccia utente (web responsive)_\r\n\r\n### Peculiarit\u00E0 del sistema e vantaggi\r\n\r\nIl sistema presenta due aspetti interessanti:\r\n\r\n1.  _l'elevata separazione dei componenti_, raggiunta grazie all'uso protocollo MQTT per la comunicazione e all'uso di Docker per il deployment delle componenti software;\r\n2.  _l'elevata scalabilit\u00E0 del sistema_, raggiunta grazie alle scelte architetturali,\r\n\r\nPer approfondire il lavoro svolto, \u00E8 possibile consultare la seguente [relazione](\/files\/relazione-sensori-parcheggio-iot.pdf), nella quale si mette anche a confronto la soluzione prodotta con un'altra meno efficace sviluppata in precedenza. I vari codici sono disponibili nelle repository Github elencate qui di seguito.", 
//     tags: [
//         tagsModel.getByKey("react-js")!, 
//         tagsModel.getByKey("mqtt")!, 
//         tagsModel.getByKey("docker")!, 
//         tagsModel.getByKey("sistemi-distribuiti")!, 
//         tagsModel.getByKey("iot")!, 
//         tagsModel.getByKey("progettazione-sviluppo-software")!, 
//     ], 
//     externalLinks: [
//         {
//             label: "Relazione [PDF]", 
//             url: "/files/relazione-sensori-parcheggio-iot.pdf", 
//             newPage: true, 
//         }, 
//         {
//             label: "Codice sensori", 
//             url: "https://github.com/rik1599/IoT2021_UltrasonicESP", 
//             newPage: true, 
//         }, 
//         {
//             label: "Codice buzzer", 
//             url: "https://github.com/Antonutti99/iot-parking-app-buzzer", 
//             newPage: true, 
//         }, 
//         {
//             label: "Container programma webcam", 
//             url: "https://github.com/rik1599/motion-raspberry-docker", 
//             newPage: true, 
//         },
//         {
//             label: "Codice interfaccia grafica", 
//             url: "https://github.com/emanuelena49/iot-parking-sensors-ui", 
//             newPage: true, 
//         },
//         {
//             label: "Docker Compose", 
//             url: "https://github.com/alexandruparaschivdumitru/iot-parking-sensor-config", 
//             newPage: true, 
//         },
//     ]
// }));


// projectsModel.addProject("applicazione-appuntamenti-medicinali-flutter", new ConcreteProject({
//     title: "Applicazione mobile per la gestione degli appuntamenti medici e dell'assunzione di medicinali", 
//     subtitle: "Progettazione di un'applicazione mobile e implementazione con Flutter", 
//     imageSrc: "/img/progetti/applicazione-medica-flutter.png", 
//     markdownBody: "Progettazione e sviluppo di un'applicazione mobile con il framework Flutter. L'applicazione si chiama _Ippocrate_, serve a gestire i propri appuntamenti medici e l'assunzione di medicinali; attualmente, non \u00E8 disponibile sul Play Store.\r\n\r\n### Funzionalit\u00E0 dell'applicazione\r\n\r\nL'applicazione - allo stato attuale - offre le seguenti funzionalit\u00E0:\r\n\r\n*   gestione dei propri appuntamenti medici (anche creando appuntamenti periodici e anche pianificando notifiche);\r\n*   gestione dei i propri farmaci (per tenere traccia delle assunzioni).\r\n\r\n### Progettazione e sviluppo\r\n\r\nPer realizzare questa applicazione, \u00E8 stato seguito un processo di sviluppo abbastanza strutturato, spiegato nel corso di [Progettazione di applicazioni mobili](https:\/\/www.dmif.uniud.it\/magistrale\/informatica\/piano-di-studio\/progettazione-di-applicazioni-mobili\/). Il progetto \u00E8 partito con una fase di [definizione dei requisiti (envision)](\/files\/envision-ippocrate.pdf); dopo di che, sono state svolte la [progettazione dell'interfaccia (design)](\/files\/design-ippocrate.pdf) e l'[l'implementazione concreta](\/files\/development-ippocrate.pdf) attraverso il framework Flutter. Durante tutto il processso, si sono tenuti diversi test su utenti per verificare e validare la fruibilit\u00E0 dell'applicazione.\r\n\r\nLa piattaforma target \u00E8 uno smarphone Android, ma essendo Flutter un framework multi-piattaforma, potenzialmente l'app potrebbe essere portata anche su iOS con poche modifiche (prevalentemente sulla parte delle notifiche).", 
//     externalLinks: [
//         {
//             label: "Envision [PDF]", newPage: true, 
//             url: "/files/envision-ippocrate.pdf"
//         }, 
//         {
//             label: "Progettazione [PDF]", newPage: true, 
//             url: "/files/design-ippocrate.pdf"
//         }, 
//         {
//             label: "Implementazione [PDF]", newPage: true, 
//             url: "/files/development-ippocrate.pdf"
//         }, 
//         {
//             label: "Repository Github", newPage: true, 
//             url: "https://github.com/emanuelena49/ippocrate"
//         }, 
//     ], 
//     tags: [
//         tagsModel.getByKey("flutter")!, 
//         tagsModel.getByKey("applicazioni-mobili")!, 
//         tagsModel.getByKey("progettazione-sviluppo-software")!
//     ]

// }));

// projectsModel.addProject("avengers-elo-rating", new ConcreteProject({
//     id: 2, 
//     title: "Avengers ELO Rating", 
//     subtitle: "Utilizzo dell'algoritmo ELO per classificare \"il livello di forza\" degli Avengers.", 
//     imageSrc: "/img/progetti/iron-man.jpg", 
//     markdownBody: "Quanto sono forti gli Avengers? Vi immaginate se fosse possibile \"classificare\" il loro livello di forza con un algoritmo? In questo progetto daremo una risposta a questa domanda sfruttando il noto [algoritmo ELO](https:\/\/it.wikipedia.org\/wiki\/Elo \"Algoritmo di classificazione ELO\") (tipicamente utilizzato negli scacchi).\r\n\r\nInnanzi tutto, per applicare l'algoritmo sono necessari _parecchi dati_; si \u00E8 costruito quindi un dataset che riepiloga tutti gli scontri avvenuti nei primi sei film del Marvel Cinematic Universe. Questo dataset, \u00E8 stato poi manipolato (attraverso il linguaggio _R_ e gli strumenti del pacchetto _Tidyverse_) per adeguarlo al formato richiesto dall'algoritmo ELO.\r\n\r\nUna volta eseguito l'algoritmo, si sono fatte un paio di analisi sui risultati ottenuti, cercando anche una correlazione lineare con lo _\"screen time\"_ dei vari personaggi.\r\n\r\nIl processo seguito viene esposto [in questa presentazione](\/files\/Avengers.html) (**Utilizzare le freccie per navigare tra le slides**). Su [Github](https:\/\/github.com\/emanuelena49\/avengers-elo-ranting-R) \u00E8 possibile trovare anche il codice sorgente e i dataset.", 
//     externalLinks: [
//         {
//             label: "Repository Github", 
//             title: "Repository Github Avengers ELO Rating", 
//             url: "https://github.com/emanuelena49/avengers-elo-ranting-R", 
//             newPage: true, 
//         }, 
//         {
//             label: "Presentazione", 
//             title: "Presentazione Avengers ELO Rating", 
//             url: "/files/Avengers.html", 
//             newPage: true, 
//         }, 
//     ], 
//     tags: [
//         tagsModel.getByKey("r")!, 
//         tagsModel.getByKey("tidyverse")!, 
//         tagsModel.getByKey("data-science")!, 
//         tagsModel.getByKey("fun")!, 
//     ]
// }));

/*
var o: {[key: string]: any} = {}

for (const i in projectsModel.getAllProjectKeys()) {
    const key = projectsModel.getAllProjectKeys()[i];
    const project = projectsModel.getProjectByKey(key);
    o[key] = project?.toObject();
}

console.log(JSON.stringify(o, null, 2));*/

export default projectsModel;
export {projectsModel, ProjectsModel};